import React from 'react';
import styled from 'styled-components';

const PageWrapper = styled.div`
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const Text = styled.h2`
  ${({ theme }) => theme.typograph.titleHeadline}
`;

const UnderDevlopmentPage = () => (
  <PageWrapper>
    <Text>Em Desenvolvimento</Text>
  </PageWrapper>
);

export default UnderDevlopmentPage;
